var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2.188h-2.438V1.25a.563.563 0 00-1.124 0v.938H5.061V1.25a.563.563 0 10-1.125 0v.938H1.5A1.312 1.312 0 00.187 3.5v15A1.313 1.313 0 001.5 19.813h15a1.313 1.313 0 001.313-1.313v-15A1.313 1.313 0 0016.5 2.187zm-15 1.124h2.438v.938a.563.563 0 101.124 0v-.938h7.875v.938a.563.563 0 001.126 0v-.938H16.5a.188.188 0 01.188.188v3.188H1.313V3.5a.187.187 0 01.187-.188zm15 15.376h-15a.188.188 0 01-.188-.188V7.812h15.376V18.5a.188.188 0 01-.188.188z",
    fill: "#5B576A"
  })));
}

export default SvgCalendarDate;